import classNames from 'classnames';
import { FC, useRef } from 'react';

import { customScrollStyles } from '@gem/ui-kit';

import { Sticker } from 'APP/components/Sticker/Sticker';
import { STICKER_POPUP_MAX_HEIGHT, STICKER_POPUP_MAX_WIDTH } from 'APP/constants/stickers';
import { ISticker } from 'APP/model/stickers/stickersModel.types';

import styles from './Stickers.styles.m.scss';

interface IStickersProps {
  stickers: ISticker[];
  stickerPackId: string;
  onClick: (sticker: ISticker) => void;
}

export const Stickers: FC<IStickersProps> = ({ stickerPackId, stickers, onClick }) => {
  const root = useRef<HTMLDivElement>(null);

  return (
    <div
      className={classNames(styles.container, customScrollStyles.container)}
      ref={root}
    >
      {stickers.map((sticker) => (
        <Sticker
          key={sticker.id}
          sticker={sticker}
          displayUILayer={1}
          maxWidth={STICKER_POPUP_MAX_WIDTH}
          maxHeight={STICKER_POPUP_MAX_HEIGHT}
          stickerPackId={stickerPackId}
          root={root.current}
          onClick={onClick}
        />
      ))}
    </div>
  );
};
